export type RendererMode = 'ascii' | 'three';

export const DEFAULT_RENDERER_MODE: RendererMode = 'three';

export const RENDERER_MODE_LABELS: Record<RendererMode, string> = {
  ascii: 'Classic ASCII',
  three: '3D Renderer',
};

export const isRendererMode = (value: unknown): value is RendererMode => {
  return value === 'ascii' || value === 'three';
};
